export default __webpack_public_path__ + "static/media/Head_5_Ear_2_C1.ffb4644f.svg";